import { render, staticRenderFns } from "./ReportBuilderForm.vue?vue&type=template&id=4a28e6b4&"
import script from "./ReportBuilderForm.vue?vue&type=script&lang=ts&"
export * from "./ReportBuilderForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports